// client/src/components/Header.js
import React, { useState } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../assets/logo-bw.png'; // Assuming logo is in the assets folder

function Header() {
  // Control the mobile menu's expanded state.
  const [expanded, setExpanded] = useState(false);

  const { isAuthenticated, logout, user, setAuthPageMessage } = useAuth();
  const navigate = useNavigate();

  const role = user?.role;

  // Dealer gets dealer-dashboard
  const isDealer = role === 'Dealer';

  // Employee hides menu items but keeps normal dashboard
  const isEmployee = role === 'Employee';

  // Supervisor hides menu items but keeps normal dashboard
  const isSupervisor = role === 'Supervisor';

  // Limited roles hide Orders/Dealers/Accounts
  const isLimitedRole = isDealer || isEmployee || isSupervisor;

  const dashboardPath = isDealer ? '/dealer-dashboard' : '/dashboard';
  const dashboardLabel = 'Dashboard';

  const handleLogout = () => {
    logout();
    // optional: clear any lingering messages
    setAuthPageMessage('', '');
    navigate('/login', { replace: true });
    // Close the menu after logging out
    setExpanded(false);
  };

  return (
    <Navbar 
      bg="dark" 
      variant="dark" 
      expand="lg" 
      className="shadow-sm"
      expanded={expanded} // Bind the navbar's expanded state to our state variable
      onToggle={() => setExpanded(!expanded)} // Toggle the state when the hamburger icon is clicked
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          {/* Company Logo */}
          <img
            src={logo}
            height="30"
            className="d-inline-block align-top me-3"
            alt="Company Logo"
          />
          Touchless Tracking
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {isAuthenticated ? (
              <>
                <Nav.Link as={Link} to={dashboardPath} onClick={() => setExpanded(false)}>{dashboardLabel}</Nav.Link>

                {/* Non-dealer links */}
                {!isLimitedRole && (
                  <>
                    <Nav.Link as={Link} to="/orders" onClick={() => setExpanded(false)}>Orders</Nav.Link>
                    <Nav.Link as={Link} to="/reports" onClick={() => setExpanded(false)}>Reports</Nav.Link>
                    <Nav.Link as={Link} to="/dealers" onClick={() => setExpanded(false)}>Dealers</Nav.Link>
                    <Nav.Link as={Link} to="/accounts" onClick={() => setExpanded(false)}>Accounts</Nav.Link>
                  </>
                )}

                {/* Settings visible to all roles */}
                <Nav.Link as={Link} to="/settings" onClick={() => setExpanded(false)}>Settings</Nav.Link>

                <Button variant="outline-light" className="ms-3" onClick={handleLogout}>
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login" onClick={() => setExpanded(false)}>Login</Nav.Link>
                <Nav.Link as={Link} to="/signup" onClick={() => setExpanded(false)}>Sign Up</Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
